/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Rails from "rails-ujs";
import $ from "jquery";
window.$ = $;
window.jquery = $;
import Turbolinks from "turbolinks";
import "./config/moment";
Turbolinks.start();
import "bootstrap";
import "./controllers";
import "../images";
import "../stylesheets/application.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import moment from "moment";

window.moment = moment;

import initNotificationChannel from "./notification/channel";

Rails.start();

document.addEventListener("DOMContentLoaded", () => {
  initNotificationChannel();
});
